export enum SeedQuantityKind {
  WEIGHT = "weight",
  NUMBER = "number",
}
